import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import DemographicsActions, { DemographicsRedux, DemographicsTypes } from '../Redux/DemographicsRedux'
import { notificationFail } from '../Redux/NotificationActions'

const demographicsCrudObservable = createCRUDObservable({
  mainRedux: DemographicsRedux,
  reduxPath: 'demographics',
})

const demographicsExcelEpic = (action$, store, { Api }) =>
  action$.ofType(DemographicsTypes.DemographicsExcelRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.demographics.getDemographicsExcel()
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            DemographicsActions.DemographicsExcelSuccess(),
          ]
        })
    ))

export const demographicsObservers = Object.assign({}, demographicsCrudObservable.observers, {})

export const demographicsEpic = combineEpics(
  demographicsCrudObservable.epic,
  demographicsExcelEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/DemographicsObservable.js